import { makeTxnPage } from "./Advances";
export default makeTxnPage({ title: "Repayments", endpoint: "/repayments", hasMonth: true, kindLabel: "Repayment", supportsImport: true });
